import styled from 'styled-components';
import { pageCard, pageCardTitle, shimmer } from '@/styles/mixins';

export const AddPaymentMethodFormWrapper = styled.section`
  ${pageCard};
  padding-inline: 2rem;

  .title {
    ${pageCardTitle};
  }

  .payment-method-options {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 2.25rem;
    margin-bottom: 1.5rem;

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
      gap: 0.875rem;
    }
  }

  .payment-method-option {
    display: flex;
    align-items: flex-start;
    gap: 1.5rem;
    padding: 1rem;
    background: ${({ theme }) => theme.colors.bannerBackground};
    border: 1px solid ${({ theme }) => theme.colors.grayDivider};
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.3s;

    &.selected {
      border-color: ${({ theme }) => theme.colors.accent};
    }
  }

  .payment-method-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .payment-method-icon {
    height: 24px;
    width: auto;
  }

  .payment-method-label {
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.grayDark};
  }

  .buttons {
    display: flex;
    gap: 0.875rem;
    justify-content: flex-end;
    padding-top: 2rem;
  }

  .other-payment-amounts {
    margin-bottom: 2rem;
  }
`;

export const PaymentSkeletonWrapper = styled.div`
  ${pageCard};
  padding-inline: 2rem;
  display: flex;
  flex-direction: column;

  .skeleton-title {
    height: 32px;
    width: 60%;
    margin-bottom: 0.5rem;
    border-radius: 4px;
    ${shimmer};
  }

  .skeleton-text {
    height: 20px;
    width: 40%;
    margin-bottom: 2rem;
    border-radius: 4px;
    ${shimmer};
  }

  .skeleton-form {
    height: 200px;
    width: 100%;
    border-radius: 4px;
    ${shimmer};
  }
`;
